<template>
    <div style="height: 400px; position: relative">
        <Spin v-if="loading" fix size="large"></Spin>
        <e-charts v-else :options="options" autoresize />
    </div>
</template>

<script>
import BarMixin from '@/views/common/m-chart-bar'
import { houseStatistic } from '@/api/ems-stats'

export default {
    name: 'assets-park-echart',
    mixins: [BarMixin],
    props: {
        currentPark: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            loading: false,
            eyList: [],
            // 1是out 2是ing 3是in
            inList: [],
            outList: [],
            ingList: [],
            lockList: [],
        }
    },

    computed: {
        options() {
            var color = [
                'rgb(2, 167, 240)',
                'rgb(245,154,35)',
                'rgb(0,191,191)',
                'rgb(244,98,59)',
            ]

            return {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
                    },
                    formatter(params, ticket, callback) {
                        console.log(params)

                        var pIn = params[0],
                            pOut = params[1],
                            pIng = params[2],
                            pLock = params[3]

                        if (pIn) {
                            return `<div class="echarts-tooltip">
                                <div class="echarts-tooltip-title">${
                                    pIn.axisValueLabel
                                }</div>
                                <div>
                                    <span class="echarts-tooltip-tag" style="background-color: ${
                                        color[pIn.seriesIndex]
                                    };"></span>
                                    <span class="echarts-tooltip-label">${
                                        pIn.seriesName
                                    }：</span>
                                    <span class="echarts-tooltip-value">${
                                        pIn.value
                                    }间  ${pIn.data.buildArea || 0}平米</span>
                                </div>
                                <div>
                                    <span class="echarts-tooltip-tag" style="background-color: ${
                                        color[pOut.seriesIndex]
                                    };"></span>
                                    <span class="echarts-tooltip-label">${
                                        pOut.seriesName
                                    }：</span>
                                    <span class="echarts-tooltip-value">${
                                        pOut.value
                                    }间  ${pOut.data.buildArea || 0}平米</span>
                                </div>
                                <div>
                                    <span class="echarts-tooltip-tag" style="background-color: ${
                                        color[pIng.seriesIndex]
                                    };"></span>
                                    <span class="echarts-tooltip-label">${
                                        pIng.seriesName
                                    }：</span>
                                    <span class="echarts-tooltip-value">${
                                        pIng.value
                                    }间  ${pIng.data.buildArea || 0}平米</span>
                                </div>
                                <div>
                                    <span class="echarts-tooltip-tag" style="background-color: ${
                                        color[pLock.seriesIndex]
                                    };"></span>
                                    <span class="echarts-tooltip-label">${
                                        pLock.seriesName
                                    }：</span>
                                    <span class="echarts-tooltip-value">${
                                        pLock.value
                                    }间  ${pLock.data.buildArea || 0}平米</span>
                                </div>
                            </div>`
                        }

                        return ''
                    },
                },
                legend: {
                    data: ['租住中', '退租/空置', '预定中', '锁定中'],
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true,
                },
                xAxis: {
                    type: 'value',
                    axisLine: {
                        lineStyle: {
                            color: '#eeeeee',
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#aaa',
                        },
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#eeeeee',
                        },
                    },
                },
                yAxis: {
                    name: '单位（间）',
                    type: 'category',
                    data: this.eyList,
                    axisLine: {
                        lineStyle: {
                            color: '#eeeeee',
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#aaa',
                        },
                    },
                    nameTextStyle: {
                        color: '#aaa',
                    },
                },
                series: [
                    {
                        name: '租住中',
                        type: 'bar',
                        stack: '总量',
                        barWidth: 14,
                        label: {
                            show: true,
                            position: 'insideRight',
                            formatter: function (params) {
                                if (params.value > 0) {
                                    return params.value
                                } else {
                                    return ''
                                }
                            },
                        },
                        data: this.inList,
                    },
                    {
                        name: '退租/空置',
                        type: 'bar',
                        stack: '总量',
                        barWidth: 14,
                        label: {
                            show: true,
                            position: 'insideRight',
                            formatter: function (params) {
                                if (params.value > 0) {
                                    return params.value
                                } else {
                                    return ''
                                }
                            },
                        },
                        data: this.outList,
                    },
                    {
                        name: '预定中',
                        type: 'bar',
                        stack: '总量',
                        barWidth: 14,
                        label: {
                            show: true,
                            position: 'insideRight',
                            formatter: function (params) {
                                if (params.value > 0) {
                                    return params.value
                                } else {
                                    return ''
                                }
                            },
                        },
                        data: this.ingList,
                    },
                    {
                        name: '锁定中',
                        type: 'bar',
                        stack: '总量',
                        barWidth: 14,
                        label: {
                            show: true,
                            position: 'insideRight',
                            formatter: function (params) {
                                if (params.value > 0) {
                                    return params.value
                                } else {
                                    return ''
                                }
                            },
                        },
                        data: this.lockList,
                    },
                ],
                color,
            }
        },
    },
    created() {
        this.fetch()
    },
    methods: {
        fetch() {
            this.loading = true
            houseStatistic(this.currentPark.id).then((res) => {
                let List = []
                res.data.floorList.sort()
                res.data.floorList.forEach((item) => {
                    List.push(item)
                    this.eyList = List
                })
                this.setData(res.data)
                this.loading = false
            })
        },
        setData(data) {
            var statusList = ['1', '2', '3', '5']
            var dataList = data.list
            var floorList = data.floorList

            // 数据补齐(全楼层、全状态)
            floorList.forEach((n) => {
                statusList.forEach((s) => {
                    let enrty = data.list.find(
                        (i) => i.houseStatus == s && i.floorName == n
                    )

                    if (!enrty) {
                        dataList.push({
                            houseStatus: s,
                            floorName: n,
                            num: '0',
                            buildArea: '0',
                        })
                    }
                })
            })

            // 按楼层排序
            dataList.sort((a, b) => (a.floorName > b.floorName ? 1 : -1))

            let outList = []
            let ingList = []
            let inList = []
            let lockList = []

            console.log(dataList)

            dataList.forEach((item) => {
                if (item.houseStatus == 1) {
                    outList.push({
                        value: item.num,
                        buildArea: item.buildArea,
                    })
                }

                if (item.houseStatus == 2) {
                    ingList.push({
                        value: item.num,
                        buildArea: item.buildArea,
                    })
                }

                if (item.houseStatus == 3) {
                    inList.push({
                        value: item.num,
                        buildArea: item.buildArea,
                    })
                }

                if (item.houseStatus == 5) {
                    lockList.push({
                        value: item.num,
                        buildArea: item.buildArea,
                    })
                }
            })
            this.outList = outList
            this.ingList = ingList
            this.inList = inList
            this.lockList = lockList
        },
    },
    watch: {
        'currentPark.id': {
            handler(val, oldVal) {
                if (val == oldVal) {
                } else {
                    this.fetch()
                }
            },
        },
    },
}
</script>

<style lang="scss" scoped></style>
